<template>
  <div class="row my-3">
    <div class="col-md-6">
      <div class="d-flex align-items-center highlight-toolbar ps-3 pe-2 py-2">
        <small class="font-body text-body-secondary"
          >Initial Fault JSON Payment</small
        >
      </div>

      <div class="highlight">
        <pre class="mt-0">
        <code class="language-javascript">
    {
      "panel_id": "your_panel_id_value",
      "incident_id": "unique_incident_id_value",
      "status": "alerting",
      "start_time": "2024-08-06T12:00:00Z",
      "end_time": "",
      "type": "power supply fault",
      "screen_percent_affected": 10
    }
      </code>
    </pre>
      </div>
    </div>
    <div class="col-md-6">
      <div class="d-flex align-items-center highlight-toolbar ps-3 pe-2 py-2">
        <small class="font-body text-body-secondary"
          >Resolution JSON Payment</small
        >
      </div>

      <div class="highlight">
        <pre class="mt-0">
        <code class="language-javascript">
  {
    "panel_id": "your_panel_id_value",
    "incident_id": "unique_incident_id_value",
    "status": "resolved",
    "start_time": "2024-08-06T12:00:00Z",
    "end_time": "2024-08-06T14:00:00Z",
    "type": "power supply fault",
    "screen_percent_affected": 10
  }
      </code>
    </pre>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'prismjs'

export default {
  mounted () {
    window.Prism = window.Prism || {}
    window.Prism.manual = true

    Prism.highlightAll()
  }
}
</script>

<style lang="scss" scoped></style>
